var _rect, _rect2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 188,
    height: 113,
    viewBox: "0 0 188 113",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 41,
    y: 56.2884,
    width: 51.7704,
    height: 51.7704,
    rx: 15.2266,
    transform: "rotate(-43.4032 41 56.2884)",
    fill: "url(#paint0_angular_822_1079)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 150.354,
    y: 59.6101,
    width: 51.7704,
    height: 51.7704,
    rx: 15.2266,
    transform: "rotate(137.022 150.354 59.6101)",
    fill: "url(#paint1_angular_822_1079)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_angular_822_1079",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(66.8852 82.1736) rotate(92.4572) scale(16.4447)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.984242,
    stopColor: "#388CC7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.990673,
    stopColor: "#388CC7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.997103,
    stopColor: "#15F647"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_angular_822_1079",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(176.24 85.4953) rotate(92.4572) scale(16.4447)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.984242,
    stopColor: "#388CC7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.990673,
    stopColor: "#388CC7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.997103,
    stopColor: "#15F647"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/Logo.b1e4745f136874bd17cab0ba50422eff.svg";
export { ForwardRef as ReactComponent };